import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=3daeacc4&scoped=true&"
import script from "./AdminPage.vue?vue&type=script&lang=ts&"
export * from "./AdminPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daeacc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3daeacc4')) {
      api.createRecord('3daeacc4', component.options)
    } else {
      api.reload('3daeacc4', component.options)
    }
    module.hot.accept("./AdminPage.vue?vue&type=template&id=3daeacc4&scoped=true&", function () {
      api.rerender('3daeacc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/admin/components/AdminPage.vue"
export default component.exports